import { AppContext } from 'providers/AppContext';
import { useContext, useMemo } from 'react';
import { buildProgressBarSteps, Labels } from './ProgressBarHelpers';

export function useProgressBar(page = '') {
	const { entityType, flowType, t } = useContext(AppContext);
	const steps = buildProgressBarSteps(entityType, flowType);
	const step = steps.indexOf(page) + 1;

	const labelsIndexes = useMemo(
		() => Labels(steps, entityType, flowType, t),
		[steps, entityType, flowType, t]
	);

	const labels = Object.keys(labelsIndexes);
	const displayStep = labels.findIndex(l => ~labelsIndexes[l].indexOf(step)) + 1;
	const progress = `${(displayStep / labels.length) * 100}%`;

	return { labels, labelsIndexes, progress, step, steps };
}
